<div *ngIf="!isEmpty(coin)" class="addCoin animate__animated animate__fadeIn">

  <div style="padding-top: 0;" class="featuredCoins">
    <h1>
      Vote for {{ coin.name }}
      <span class="promote">
        <a routerLink="/advertise">Promote {{ coin.name }}!</a>
      </span>
    </h1>
  </div>

  <div class="details errorMessageTop">

    <p *ngIf="errorMessage" class="errorMessage">
      {{ errorMessage }}
    </p>

    <p *ngIf="coin.votes < 100" class="errorMessage">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ coin.name }} needs {{ 100 - coin.votes }} more votes to get listed on homepage.
    </p>

    <div class="row">
      <div class="col-lg-9 col-md-8">
        <div class="row">
          <div class="col-lg-3 v-align">
            <div class="image">
              <img [defaultImage]="'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAcSURBVHic7cGBAAAAAMOg+VNf4QBVAQAAAAB8BhRQAAHaoBD5AAAAAElFTkSuQmCC'" [lazyLoad]="'https://api.coincatapult.com/storage/images/logo/'+coin.logo" onError="this.style.display = 'none'" alt="{{ coin.name }} Logo">
              <div class="smallImagesMobile">
                <a rel="nofollow noopener" *ngIf="coin.network=='eth'" title="View on Etherscan" target="_blank" href="https://etherscan.io/token/{{ coin.contract }}">
                  <img [lazyLoad]="'assets/images/etherscan.png'" alt="View on Etherscan">
                </a>
                <a rel="nofollow noopener" *ngIf="coin.network=='bsc'" title="View on BscScan" target="_blank" href="https://bscscan.com/token/{{ coin.contract }}">
                  <img [lazyLoad]="'assets/images/bscscan.png'" alt="View on BscScan">
                </a>
                <a rel="nofollow noopener" *ngIf="coin.network=='sui'" title="View on SuiVision" target="_blank" href="https://suivision.xyz/coin/{{ coin.contract }}">
                  <img [lazyLoad]="'assets/images/suivision.png'" alt="View on SuiVision">
                </a>
                <a rel="nofollow noopener" *ngIf="coin.network=='arb'" title="View on Arbiscan" target="_blank" href="https://arbiscan.io/token/{{ coin.contract }}">
                  <img [lazyLoad]="'assets/images/arbiscan.png'" alt="View on Arbiscan">
                </a>
                <a rel="nofollow noopener" *ngIf="coin.network=='base'" title="View on BaseScan" target="_blank" href="https://basescan.org/token/{{ coin.contract }}">
                  <img [lazyLoad]="'assets/images/basescan.png'" alt="View on BaseScan">
                </a>
                <a rel="nofollow noopener" *ngIf="coin.network=='base'" title="View on BlockScout" target="_blank" href="https://base.blockscout.com/token/{{ coin.contract }}">
                  <img [lazyLoad]="'assets/images/base-scout.svg'" alt="View on BlockScout">
                </a>
                <a rel="nofollow noopener" *ngIf="coin.network=='tron' && isNumberContract(coin)" title="View on Tronscan" target="_blank" href="https://tronscan.org/#/token/{{ coin.contract }}">
                  <img [lazyLoad]="'assets/images/tronscan.png'" alt="View on Tronscan">
                </a>
                <a rel="nofollow noopener" *ngIf="coin.network=='tron' && !isNumberContract(coin)" title="View on Tronscan" target="_blank" href="https://tronscan.org/#/token20/{{ coin.contract }}">
                  <img [lazyLoad]="'assets/images/tronscan.png'" alt="View on Tronscan">
                </a>
                <a rel="nofollow noopener" *ngIf="coin.network=='harmony'" title="View on Harmony Explorer" target="_blank" href="https://explorer.harmony.one/address/{{ coin.contract }}">
                  <img [lazyLoad]="'assets/images/icons/harmony.svg'" alt="View on Harmony Explorer">
                </a>

                <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cmc" target="_blank" href="https://coinmarketcap.com/currencies/{{ coin.tmp.cmc }}">
                  <img src="assets/images/coinmarketcap.png" alt="View on CoinMarketCap">
                </a>
                <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cg" target="_blank" href="https://www.coingecko.com/en/coins/{{ coin.tmp.cg }}">
                  <img src="assets/images/coingecko.png" alt="View on CoinGecko">
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-9 v-align">
            <div class="coinDetails">
              <h2>
                <span>{{ coin.name }}</span> - <span class="bold">${{ coin.symbol }}</span>
              </h2>
              <p (click)="copyMessage(coin.contract)" class="address">
                <span>
                  Contract address:
                </span>
                <span class="bold" title="{{ coin.contract }}">
                  {{ coin.contract | slice:0:8 }}..{{ coin.contract | slice:-6 }}
                </span>
                <i class="fa fa-clone" aria-hidden="true"></i>
                <span *ngIf="copied" class="copied animate__animated animate__fadeIn">
                   Copied!
                </span>
              </p>
              <ul>
                <li [ngClass]="{'listed': coin.status == 1, 'unlisted': coin.status == 0, 'featured': coin.status == 2}">
                  Status:
                  <span *ngIf="coin.status == 0">New</span>
                  <span *ngIf="coin.status == 1">Listed</span>
                  <span *ngIf="coin.status == 2">Featured</span>
                </li>
                <li>
                  Votes: <span>{{ coin.votes }}</span>
                </li>
                <li>
                  Votes Today: <span>{{ coin.votesToday }}</span>
                </li>
                <li>
                  Network:
                  <span style="text-transform: uppercase">
                    <img class="network" *ngIf="coin.network == 'solana'" src="assets/images/icons/solana.svg" alt="Solana">
                    <img class="network" *ngIf="coin.network == 'eth'" src="assets/images/icons/eth.svg" alt="Ethereum">
                    <img class="network" *ngIf="coin.network == 'bsc'" src="assets/images/icons/bsc.svg" alt="BSC">
                    <img class="network" *ngIf="coin.network == 'sui'" src="assets/images/icons/sui.svg" alt="SUI">
                    <img class="network" *ngIf="coin.network == 'base'" src="assets/images/icons/base.svg" alt="Base">
                    <img class="network" *ngIf="coin.network == 'tron'" src="assets/images/icons/tron.png" alt="Tron">
                    <img class="network" *ngIf="coin.network == 'harmony'" src="assets/images/icons/harmony.svg" alt="Harmony">
                    <img class="network" *ngIf="coin.network == 'polygon'" src="assets/images/icons/polygon.svg" alt="Polygon">
                    <img class="network" *ngIf="coin.network == 'algorand'" src="assets/images/icons/algorand.svg" alt="Algorand">
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="description">
          <p>
            {{ coin.description }}
          </p>
          <h5>
            Vote for {{ coin.name }}
          </h5>
          <button [disabled]="coin.timeToVote > 0" (click)="vote()" class="btn btn-primary-custom" [ngClass]="{'widthAuto': coin.timeToVote > 0}">
            <span *ngIf="!loader">
              <span *ngIf="!coin.timeToVote">Vote</span> <span *ngIf="coin.timeToVote > 0">You can vote again in: <countdown [config]="{leftTime: coin.timeToVote, format: 'HH:mm:ss'}" (event)="handleEvent($event)"></countdown></span>
            </span>
            <div *ngIf="loader" class="buttonLoading">
              <div class="lds-ring page"><div></div><div></div><div></div><div></div></div>
            </div>
          </button>
          <p class="info">
            You can vote once every 6 hours.
          </p>
        </div>
        <p class="info hidden-xs">
          <b>Disclaimer</b>: CoinCatapult does not endorse {{ coin.symbol }}. Please <b>Do Your Own Research (DYOR)</b> before investing in any project.
        </p>
        <p class="info hidden-xs">
          Information incorrect? Please report it to <a routerLink="/contact">contact@coincatapult.com</a>
        </p>
      </div>
      <div class="col-lg-3 col-md-4">
        <div class="sidebarDetails">
          <h4>
            Information
          </h4>
          <ul>
            <li>
              Launched: <span><i class="fa fa-calendar"></i> {{ transformDate(coin.launch) }}</span>
            </li>
            <li>
              Added: <span><i class="fa fa-calendar"></i> {{ transformDate(coin.created_at) }}</span>
            </li>
          </ul>
          <h4>Social:</h4>
          <ul>
            <li *ngIf="coin.social.website">
              Website:
              <span>
                <i class="fa fa-globe"></i>
                <a *ngIf="coin.status == 2" rel="noopener" target="_blank" href="{{ coin.social.website }}">Visit website</a>
                <a *ngIf="coin.status != 2" rel="nofollow noopener" target="_blank" href="{{ coin.social.website }}">Visit website</a>
              </span>
            </li>
            <li *ngIf="coin.social.telegram">
              Telegram: <span><i class="fa fa-telegram"></i> <a rel="nofollow noopener" target="_blank" href="{{ coin.social.telegram }}">Join Telegram</a></span>
            </li>
            <li *ngIf="coin.social.email">
              Email: <span><i class="fa fa-envelope"></i> <a rel="nofollow noopener" href="mailto:{{ coin.social.email }}">Contact</a></span>
            </li>
            <li *ngIf="coin.social.twitter">
              Twitter: <span><i class="fa fa-twitter"></i> <a rel="nofollow noopener" target="_blank" href="{{ coin.social.twitter }}">Follow Twitter</a></span>
            </li>
            <li *ngIf="coin.social.reddit">
              Reddit: <span><i class="fa fa-reddit" aria-hidden="true"></i> <a rel="nofollow noopener" target="_blank" href="{{ coin.social.reddit }}">Follow Reddit</a></span>
            </li>
            <li *ngIf="coin.social.discord">
              Discord: <span><img class="socialIcon" src="assets/images/icons/discord.svg" alt="discord"> <a rel="nofollow noopener" target="_blank" href="{{ coin.social.discord }}">Join Discord</a></span>
            </li>
            <li *ngIf="coin.social.facebook">
              Facebook: <span><i class="fa fa-facebook" aria-hidden="true"></i> <a rel="nofollow noopener" target="_blank" href="{{ coin.social.facebook }}">Follow Facebook</a></span>
            </li>
            <li *ngIf="coin.social.instagram">
              Instagram: <span><i class="fa fa-instagram" aria-hidden="true"></i> <a rel="nofollow noopener" target="_blank" href="{{ coin.social.instagram }}">Follow Instagram</a></span>
            </li>
          </ul>

<!--          <h4 *ngIf="coin.exchanges && !this.isEmpty(coin.exchanges)">Exchanges:</h4>-->
<!--          <ul *ngIf="coin.exchanges && !this.isEmpty(coin.exchanges)">-->
<!--            <li *ngIf="coin.exchanges.hotbit">-->
<!--              Hotbit: <span><img class="icon" src="assets/images/hotbit.png" alt=""> <a rel="nofollow noopener" target="_blank" href="{{ coin.exchanges.hotbit }}">Hotbit</a></span>-->
<!--            </li>-->
<!--          </ul>-->

          <h4 *ngIf="coin.exchanges && coin.exchanges.length > 0">Exchanges:</h4>
          <ul *ngIf="coin.exchanges && coin.exchanges.length > 0" class="charts">
            <li *ngFor="let exchange of coin.exchanges; let index = index; trackBy:trackByIndex;">
              <span>
                <a rel="nofollow noopener" target="_blank" href="{{ exchange.pivot.url }}">
                  <img src="{{ exchange.image }}" alt="">
                  {{ exchange.name }}
                </a>
              </span>
            </li>
          </ul>

          <h4 *ngIf="coin.charts && coin.charts.length > 0">Charts:</h4>
          <ul class="charts">
            <li *ngIf="coin.tmp && coin.tmp.cmc">
               <span>
                <a rel="nofollow noopener" title="View coinmarketcap" target="_blank" href="https://coinmarketcap.com/currencies/{{ coin.tmp.cmc }}">
                  <img src="assets/images/coinmarketcap.png" alt="View on coinmarketcap"> CoinMarketCap
                </a>
               </span>
            </li>
            <li *ngIf="coin.tmp && coin.tmp.cg">
              <span>
                <a rel="nofollow noopener" title="View on coingecko" target="_blank" href="https://www.coingecko.com/en/coins/{{ coin.tmp.cg }}">
                  <img src="assets/images/coingecko.png" alt="View on coingecko"> CoinGecko
                </a>
              </span>
            </li>
            <li *ngFor="let chart of coin.charts; let index = index; trackBy:trackByIndex;">
              <span>
                <a rel="nofollow noopener" target="_blank" href="{{ chart.url }}">
                  <img src="assets/images/{{ chart.icon }}" alt="">
                  {{ chart.name }}
                </a>
              </span>
            </li>
          </ul>


        </div>

        <p class="info hidden-md">
          <b>Disclaimer</b>: CoinCatapult does not endorse {{ coin.name }} (${{ coin.symbol }}). Please <b>Do Your Own Research (DYOR)</b> before investing in the project.
        </p>
        <p class="info hidden-md">
          Information incorrect? Please report it to <a routerLink="/contact">contact@coincatapult.com</a>
        </p>
      </div>
    </div>
  </div>

  <div class="featuredCoins">
    <h2>
      Featured coins
      <span class="promote">
        <a routerLink="/advertise">Promote your coin!</a>
      </span>
    </h2>

    <div class="mobileTable mobileTableFeatured">
      <ul class="header">
        <li class="w10">#</li>
        <li class="w40">Name</li>
        <li class="w20">Votes</li>
        <li class="w30">Vote</li>
      </ul>
      <ul (click)="navigate(coin)" *ngFor="let coin of coins; let index = index; trackBy:trackByIndex;" [ngClass]="{'one': index%2 == 0, 'two': index%2 != 0}" class="body">
        <li class="w10">{{ index+1 }}</li>
        <li class="w40">
          <div style="text-align: center;">
            <img class="logo" [defaultImage]="'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAcSURBVHic7cGBAAAAAMOg+VNf4QBVAQAAAAB8BhRQAAHaoBD5AAAAAElFTkSuQmCC'" [lazyLoad]="'https://api.coincatapult.com/storage/images/logo/'+coin.logo" onError="this.style.display = 'none'" alt="Image">
            <span>
              <span class="name">
                {{ coin.name }}
              </span>
              <span class="network">
                <img class="network" *ngIf="coin.network == 'bsc'" src="assets/images/icons/bsc.svg" alt="BSC">
                <img class="network" *ngIf="coin.network == 'sui'" src="assets/images/icons/sui.svg" alt="SUI">
                <img class="network eth" *ngIf="coin.network == 'eth'" src="assets/images/icons/eth.svg" alt="Ethereum">
                <img class="network" *ngIf="coin.network == 'tron'" src="assets/images/icons/tron.png" alt="TRON">
                <img class="network" *ngIf="coin.network == 'harmony'" src="assets/images/icons/harmony.svg" alt="Harmony">
                <img class="network" *ngIf="coin.network == 'polygon'" src="assets/images/icons/polygon.svg" alt="Polygon">
                <img class="network" *ngIf="coin.network == 'algorand'" src="assets/images/icons/algorand.svg" alt="Algorand">
                <img class="network" *ngIf="coin.network == 'solana'" src="assets/images/icons/solana.svg" alt="Solana">
              </span>
            </span>
            <span class="symbol">
              {{ coin.symbol }}
            </span>
            <div class="smallImagesMobile">
              <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cg" title="View oncoingecko" target="_blank" href="https://www.coingecko.com/en/coins/{{ coin.tmp.cg }}">
                <img src="assets/images/coingecko.png" alt="View on coingecko">
              </a>

              <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cmc" title="View coinmarketcap" target="_blank" href="https://coinmarketcap.com/currencies/{{ coin.tmp.cmc }}">
                <img src="assets/images/coinmarketcap.png" alt="View on coinmarketcap">
              </a>
            </div>
          </div>
        </li>
        <li class="w20"><span class="coinVotesCount">{{ coin.votes }}</span></li>
        <li class="w30">
          <button [disabled]="coin.timeToVote > 0" class="btn btn-primary-custom">
            <span>
              <span *ngIf="!coin.timeToVote">Vote</span> <span *ngIf="coin.timeToVote > 0"><countdown [config]="{leftTime: coin.timeToVote, format: 'HH:mm:ss'}" (event)="handleEventList($event, coin)"></countdown></span>
            </span>
          </button>
        </li>
      </ul>
    </div>

    <div class="table-responsive featuredTable">
      <table class="table">
        <thead>
          <tr>
            <th class="radiusLT" scope="col">#</th>
            <th scope="col"></th>
            <th scope="col">Name</th>
            <th scope="col">Chain</th>
            <th scope="col">Symbol</th>
            <th scope="col">Votes</th>
            <th scope="col">Launch date</th>
            <th class="radiusRT" scope="col">Vote</th>
          </tr>
        </thead>
        <tbody style="background-color: #21252b;">
          <tr (click)="navigate(coin)" *ngFor="let coin of coins; let index = index; trackBy:trackByIndex;" [ngClass]="{'one': index%2 == 0, 'two': index%2 != 0}">
            <th class="radiusLB" scope="row">{{ index + 1 }}</th>
            <td class="v-align">
              <img [defaultImage]="'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAcSURBVHic7cGBAAAAAMOg+VNf4QBVAQAAAAB8BhRQAAHaoBD5AAAAAElFTkSuQmCC'" [lazyLoad]="'https://api.coincatapult.com/storage/images/logo/'+coin.logo" onError="this.style.display = 'none'" alt="Image">
              <div class="smallImages">
                <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cg" title="View on coingecko" target="_blank" href="https://www.coingecko.com/en/coins/{{ coin.tmp.cg }}">
                  <img src="assets/images/coingecko.png" alt="View on coingecko">
                </a>

                <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cmc" title="View on coinmarketcap" target="_blank" href="https://coinmarketcap.com/currencies/{{ coin.tmp.cmc }}">
                  <img src="assets/images/coinmarketcap.png" alt="View on coinmarketcap">
                </a>
              </div>
            </td>
            <td>{{ coin.name }}</td>
            <td>
              <img class="network" *ngIf="coin.network == 'bsc'" src="assets/images/icons/bsc.svg" alt="BSC">
              <img class="network" *ngIf="coin.network == 'sui'" src="assets/images/icons/sui.svg" alt="SUI">
              <img class="network eth" *ngIf="coin.network == 'eth'" src="assets/images/icons/eth.svg" alt="Ethereum">
              <img class="network" *ngIf="coin.network == 'tron'" src="assets/images/icons/tron.png" alt="TRON">
              <img class="network" *ngIf="coin.network == 'harmony'" src="assets/images/icons/harmony.svg" alt="Harmony">
              <img class="network" *ngIf="coin.network == 'polygon'" src="assets/images/icons/polygon.svg" alt="Polygon">
              <img class="network" *ngIf="coin.network == 'algorand'" src="assets/images/icons/algorand.svg" alt="Algorand">
              <img class="network" *ngIf="coin.network == 'solana'" src="assets/images/icons/solana.svg" alt="Solana">
            </td>
            <td>{{ coin.symbol }}</td>
            <td><span class="coinVotesCount">{{ coin.votes }}</span></td>
            <td>
              {{ coin.launch_date }}
            </td>
            <td class="radiusRB">
              <button [disabled]="coin.timeToVote > 0" class="btn btn-primary-custom">
                <span>
                  <span *ngIf="!coin.timeToVote">Vote</span> <span *ngIf="coin.timeToVote > 0"><countdown [config]="{leftTime: coin.timeToVote, format: 'HH:mm:ss'}" (event)="handleEventList($event, coin)"></countdown></span>
                </span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div *ngIf="loading" class="loader">
  <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
</div>
